import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableToCableClearanceType =
    | 'touching'
    | 'one-cable-diameter'
    | '0.125-m'
    | '0.25-m'
    | '0.5-m'
    | 'more-than-two-cable-diameter'
    | 'spaced'
    | 'trefoil';

const options = [
    { value: 'touching', label: 'Touching' },
    { value: 'one-cable-diameter', label: 'One Cable Diameter' },
    { value: '0.125-m', label: '0.125 m' },
    { value: '0.25-m', label: '0.25 m' },
    { value: '0.5-m', label: '0.5 m' },
    { value: 'more-than-two-cable-diameter', label: 'More than two cable diameters' },
    { value: 'spaced', label: 'Spaced' },
    { value: 'trefoil', label: 'Trefoil' },
] as Option<CableToCableClearanceType>[];

const validator = z.enum([
    'touching',
    'one-cable-diameter',
    '0.125-m',
    '0.25-m',
    '0.5-m',
    'more-than-two-cable-diameter',
    'spaced',
    'trefoil',
]);

export const CableToCableClearance = {
    validator,
    options,
};
